import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ModernTireLandingPage from './components/ModernTireLandingPage';
import Impressum from './components/Impressum';
import Datenschutz from './components/Datenschutz';
import LagerSystem from './components/LagerSystem';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<ModernTireLandingPage />} />
        <Route path="/preise" element={<Preise />} />
        <Route path="/ueber-uns" element={<UeberUns />} />
        <Route path="/impressum" element={<Impressum />} />
        <Route path="/datenschutz" element={<Datenschutz />} />
        <Route path="/lager" element={<LagerSystem />} />
      </Routes>
    </Router>
  );
}

// Temporäre Komponenten - ersetze diese später mit deinen echten Seiten
const Preise = () => (
  <div style={{ padding: '2rem' }}>
    <h1>Preise</h1>
    <p>Hier kommen deine Preise hin...</p>
  </div>
);

const UeberUns = () => (
  <div style={{ padding: '2rem' }}>
    <h1>Über uns</h1>
    <p>Hier kommt deine Über uns Seite hin...</p>
  </div>
);

export default App;